import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { filter } from 'lodash';
import ProductApi from '../../../lib/api/product/ProductApi';
import {
  asyncSimpleModal,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
  setResponseListForm,
} from '../../../lib/common';
import toastMsg from '../../../lib/toastMsg';
import noticeExcelDownloadResult from '../../../lib/noticeExcelDownloadResult';
import { appActions } from '../app';
import { productActions } from './index';
import productToastMsg from '../../../constants/service/toastMsg/productToastMsg';
import { PRODUCT_RES_CODE } from '../../../constants/responseCode/productResCode';
import {
  PRODUCT_ALL_LIST_URL_PATH,
  PRODUCT_APPROVAL_LIST_URL_PATH,
  PRODUCT_BAN_LIST_URL_PATH,
  PRODUCT_PROPERTY_REQUEST_LIST_URL_PATH,
} from '../../../constants/service/common/urlConstants';

function* fetchList() {
  /**
   *  [상품 전체 리스트] 상품 전체 리스트 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_ALL_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductAllList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.GET_PRODUCT_ALL_LIST_REQUEST_SUCCESS);
        const data = {
          productList: setResponseListForm(result.data.productAllList, result.data.totalCnt, payload),
        };
        yield put({ type: productActions.GET_PRODUCT_LIST_SUCCESS, payload: data });

        /**
         *  현재 어떤 목록 페이지 인지 기록
         */
        yield put(
          productActions.setData({
            path: ['listPageUrl'],
            value: PRODUCT_ALL_LIST_URL_PATH,
          }),
        );

        if (payload.isInit) {
          /**
           *  상품 카테고리
           */
          yield put(
            productActions.setData({
              path: ['categorySelectList'],
              value: result.data.categorySelectList,
            }),
          );

          /**
           *  태그 그룹 리스트
           */
          yield put(
            productActions.setData({
              path: ['productList', 'tagGroupList'],
              value: result.data.tagGroupList,
            }),
          );

          /**
           *  태그 리스트
           */
          yield put(
            productActions.setData({
              path: ['productList', 'tagList'],
              value: result.data.tagList,
            }),
          );
        }
      }
    } catch (error) {
      toastMsg.error(productToastMsg.GET_PRODUCT_ALL_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 승인 리스트] 상품 승인 리스트 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_APPROVAL_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductApprovalList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.GET_PRODUCT_APPROVAL_LIST_REQUEST_SUCCESS);

        const data = {
          productList: setResponseListForm(result.data.productApprovalList, result.data.totalCnt, payload),
        };
        yield put({ type: productActions.GET_PRODUCT_LIST_SUCCESS, payload: data });

        /**
         *  현재 어떤 목록 페이지 인지 기록
         */
        yield put(
          productActions.setData({
            path: ['listPageUrl'],
            value: PRODUCT_APPROVAL_LIST_URL_PATH,
          }),
        );

        /**
         *  상품 카테고리
         */
        yield put(
          productActions.setData({
            path: ['categorySelectList'],
            value: result.data.categorySelectList,
          }),
        );

        /**
         *  태그 그룹 리스트
         */
        yield put(
          productActions.setData({
            path: ['productList', 'tagGroupList'],
            value: result.data.tagGroupList,
          }),
        );

        /**
         *  태그 리스트
         */
        yield put(
          productActions.setData({
            path: ['productList', 'tagList'],
            value: result.data.tagList,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(productToastMsg.GET_PRODUCT_APPROVAL_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 금지 리스트] 상품 금지 리스트 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_BAN_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductBanList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.GET_PRODUCT_BAN_LIST_REQUEST_SUCCESS);

        const data = {
          productList: setResponseListForm(result.data.productBanList, result.data.totalCnt, payload),
        };
        yield put({ type: productActions.GET_PRODUCT_LIST_SUCCESS, payload: data });

        /**
         *  현재 어떤 목록 페이지 인지 기록
         */
        yield put(
          productActions.setData({
            path: ['listPageUrl'],
            value: PRODUCT_BAN_LIST_URL_PATH,
          }),
        );

        /**
         *  상품 카테고리
         */
        yield put(
          productActions.setData({
            path: ['categorySelectList'],
            value: result.data.categorySelectList,
          }),
        );

        /**
         *  태그 그룹 리스트
         */
        yield put(
          productActions.setData({
            path: ['productList', 'tagGroupList'],
            value: result.data.tagGroupList,
          }),
        );

        /**
         *  태그 리스트
         */
        yield put(
          productActions.setData({
            path: ['productList', 'tagList'],
            value: result.data.tagList,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(productToastMsg.GET_PRODUCT_BAN_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 리스트 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductPropertyRequestList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        productList: {
          ...setResponseListForm(result.data.productPropertyRequestList, result.data.totalCnt, payload),
          mainProductCategorySelectList: result.data.mainProductCategorySelectList,
          subProductCategorySelectList: result.data.subProductCategorySelectList,
        },
      };

      toastMsg.success(productToastMsg.GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST_SUCCESS);

      yield put({ type: productActions.GET_PRODUCT_LIST_SUCCESS, payload: data });
      /**
       *  현재 어떤 목록 페이지 인지 기록
       */
      yield put(
        productActions.setData({
          path: ['listPageUrl'],
          value: PRODUCT_PROPERTY_REQUEST_LIST_URL_PATH,
        }),
      );
    } catch (error) {
      toastMsg.error(productToastMsg.GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 excel 리스트 다운로드 하기
   */
  yield takeEvery(productActions.GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductPropertyRequestExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || productToastMsg.GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 승인 리스트] 상품 승인 excel 리스트 다운로드 하기
   */
  yield takeEvery(productActions.GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductApprovalExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || productToastMsg.GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 금지 리스트] 상품 금지 excel 리스트 다운로드 하기
   */
  yield takeEvery(productActions.GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductBanExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || productToastMsg.GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [상품 리스트] 태그 리스트 가져오기
   */
  yield takeEvery(productActions.GET_PRODUCT_TAG_COLUMN_TAG_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductTagColumnTagList, setRequestForm(payload));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      /**
       *  태그 보기 모달 띄우기
       */
      yield put(
        appActions.appToggleModal({
          name: 'tagListViewModal',
          data: result.data,
        }),
      );
    } catch (e) {
      toastMsg.error(productToastMsg.GET_PRODUCT_TAG_COLUMN_TAG_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [상품 상세] 상품 거절 사유 리스트 요청하기
   */
  yield takeEvery(productActions.GET_REJECT_REASON_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getRejectReasonList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.GET_REJECT_REASON_LIST_REQUEST_SUCCESS);

        yield put(
          productActions.toggleModal({
            name: 'rejectReasonListModal',
            data: {
              rejectReasonList: result.data.rejectReasonList,
            },
            value: true,
          }),
        );
      }
    } catch (error) {
      toastMsg.error(productToastMsg.GET_REJECT_REASON_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 삭제] 상품 삭제 요청하기
   */
  yield takeEvery(productActions.DELETE_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.deleteProduct, setRequestForm(payload, true));

      /**
       *  이동할 페이지 url
       */
      const path = yield select((state) =>
        state.product.listPageUrl ? state.product.listPageUrl : PRODUCT_ALL_LIST_URL_PATH,
      );

      /**
       *  검색 조건
       */
      const state = yield select((state) => {
        return {
          searchData: state.product.productList.searchData,
          searchOption: state.product.productList.searchOption,
          filterOption: state.product.productList.filterOption,
          sortOption: state.product.productList.sortOption,
          pagination: state.product.productList.pagination,
        };
      });

      if (result.msg) {
        /**
         *  상품의 데이터가 이미 수정된 데이터인 경우
         */
        if (result.status === PRODUCT_RES_CODE.ALREADY_EDITED_DATA) {
          yield asyncSimpleModal({
            type: 'error',
            title: '상품 삭제 에러',
            message: result.msg,
          });

          reDirectPage({
            path: PRODUCT_ALL_LIST_URL_PATH,
            state,
          });
        } else {
          toastMsg.error(result.msg);
        }
      } else {
        toastMsg.success(productToastMsg.DELETE_PRODUCT_REQUEST_SUCCESS);

        reDirectPage({
          path,
          state,
        });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.DELETE_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 등록 승인] 상품 등록 승인 요청하기
   */
  yield takeEvery(productActions.PERMIT_REGISTRATION_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.permitRegistrationProduct, setRequestForm(payload, true));

      /**
       *  이동할 페이지 url
       */
      const path = yield select((state) =>
        state.product.listPageUrl ? state.product.listPageUrl : PRODUCT_APPROVAL_LIST_URL_PATH,
      );

      /**
       *  검색 조건
       */
      const state = yield select((state) => {
        return {
          searchData: state.product.productList.searchData,
          searchOption: state.product.productList.searchOption,
          filterOption: state.product.productList.filterOption,
          sortOption: state.product.productList.sortOption,
          pagination: state.product.productList.pagination,
        };
      });

      if (result.msg) {
        /**
         *  상품의 데이터가 이미 수정된 데이터인 경우
         */
        if (result.status === PRODUCT_RES_CODE.ALREADY_EDITED_DATA) {
          yield asyncSimpleModal({
            type: 'error',
            title: '상품 승인 에러',
            message: result.msg,
          });

          reDirectPage({
            path,
            state,
          });
        } else {
          toastMsg.error(result.msg);
        }
      } else {
        toastMsg.success(productToastMsg.PERMIT_REGISTRATION_PRODUCT_REQUEST_SUCCESS);

        reDirectPage({
          path,
          state,
        });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.PERMIT_REGISTRATION_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 등록 거절] 상품 등록 거절 요청하기
   */
  yield takeEvery(productActions.REJECT_REGISTRATION_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.rejectRegistrationProduct, setRequestForm(payload, true));

      /**
       *  이동할 페이지 url
       */
      const path = yield select((state) =>
        state.product.listPageUrl ? state.product.listPageUrl : PRODUCT_APPROVAL_LIST_URL_PATH,
      );

      /**
       *  검색 조건
       */
      const state = yield select((state) => {
        return {
          searchData: state.product.productList.searchData,
          searchOption: state.product.productList.searchOption,
          filterOption: state.product.productList.filterOption,
          sortOption: state.product.productList.sortOption,
          pagination: state.product.productList.pagination,
        };
      });

      if (result.msg) {
        /**
         *  상품의 데이터가 이미 수정된 데이터인 경우
         */
        if (result.status === PRODUCT_RES_CODE.ALREADY_EDITED_DATA) {
          yield asyncSimpleModal({
            type: 'error',
            title: '상품 승인 에러',
            message: result.msg,
          });

          reDirectPage({
            path,
            state,
          });
        } else {
          toastMsg.error(result.msg);
        }
      } else {
        toastMsg.success(productToastMsg.REJECT_REGISTRATION_PRODUCT_REQUEST_SUCCESS);

        reDirectPage({
          path,
          state,
        });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.REJECT_REGISTRATION_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 판매 금지 승인] 상품 판매 금지 승인 요청하기
   */
  yield takeEvery(productActions.PERMIT_BAN_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.permitBanProduct, setRequestForm(payload, true));

      /**
       *  이동할 페이지 url
       */
      const path = yield select((state) =>
        state.product.listPageUrl ? state.product.listPageUrl : PRODUCT_BAN_LIST_URL_PATH,
      );

      /**
       *  검색 조건
       */
      const state = yield select((state) => {
        return {
          searchData: state.product.productList.searchData,
          searchOption: state.product.productList.searchOption,
          filterOption: state.product.productList.filterOption,
          sortOption: state.product.productList.sortOption,
          pagination: state.product.productList.pagination,
        };
      });

      if (result.msg) {
        /**
         *  상품의 데이터가 이미 수정된 데이터인 경우
         */
        if (result.status === PRODUCT_RES_CODE.ALREADY_EDITED_DATA) {
          yield asyncSimpleModal({
            type: 'error',
            title: '상품 판매 금지 에러',
            message: result.msg,
          });

          reDirectPage({
            path,
            state,
          });
        } else {
          toastMsg.error(result.msg);
        }
      } else {
        toastMsg.success(productToastMsg.PERMIT_BAN_PRODUCT_REQUEST_SUCCESS);

        reDirectPage({
          path,
          state,
        });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.PERMIT_BAN_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 판매 금지] 상품 판매 금지 요청하기
   */
  yield takeEvery(productActions.REJECT_BAN_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.rejectBanProduct, setRequestForm(payload, true));

      /**
       *  이동할 페이지 url
       */
      const path = yield select((state) =>
        state.product.listPageUrl ? state.product.listPageUrl : PRODUCT_BAN_LIST_URL_PATH,
      );

      /**
       *  검색 조건
       */
      const state = yield select((state) => {
        return {
          searchData: state.product.productList.searchData,
          searchOption: state.product.productList.searchOption,
          filterOption: state.product.productList.filterOption,
          sortOption: state.product.productList.sortOption,
          pagination: state.product.productList.pagination,
        };
      });

      if (result.msg) {
        /**
         *  상품의 데이터가 이미 수정된 데이터인 경우
         */
        if (result.status === PRODUCT_RES_CODE.ALREADY_EDITED_DATA) {
          yield asyncSimpleModal({
            type: 'error',
            title: '상품 판매 금지 에러',
            message: result.msg,
          });

          reDirectPage({
            path,
            state,
          });
        } else {
          toastMsg.error(result.msg);
        }
      } else {
        toastMsg.success(productToastMsg.REJECT_BAN_PRODUCT_REQUEST_SUCCESS);

        reDirectPage({
          path,
          state,
        });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.REJECT_BAN_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 버전] 상품 버전 정보 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_VERSION_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductVersion, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.GET_PRODUCT_VERSION_INFO_REQUEST_SUCCESS);

        yield put({ type: productActions.GET_PRODUCT_VERSION_INFO_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.GET_PRODUCT_VERSION_INFO_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 버전] 상품 버전 상세 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_VERSION_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductVersionDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.GET_PRODUCT_VERSION_DETAIL_REQUEST_SUCCESS);

        yield put({ type: productActions.GET_PRODUCT_VERSION_DETAIL_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.GET_PRODUCT_VERSION_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 상세] 사방넷으로 상품 정보 전송
   */
  yield takeEvery(productActions.SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.sendProductDataToSabangnet, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(productToastMsg.SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST_SUCCESS);

        reDirectPage({ path: PRODUCT_ALL_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(productToastMsg.SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST_ERROR, error);
    }
  });

  /**
   *  엑셀 일괄 상품 할인 변경하기
   */
  yield takeEvery(productActions.EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.excelBulkEditProductDiscount, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        /**
         *  엑셀 일괄 상품 할인 변경 성공 시
         *  업데이트된 상품 리스트보여주기
         */
        if (result.data.isSuccess) {
          toastMsg.success(productToastMsg.EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST_SUCCESS);
          const { productList } = result.data;
          yield put(
            productActions.toggleModal({
              name: 'excelBulkEditProductDiscountSuccessModal',
              value: true,
              data: {
                productList,
              },
            }),
          );
        } else {
          /**
           *  엑셀 일괄 상품 할인 변경 실패 시
           *  실패사유를 보여주는 모달을 열기
           */
          const { productList } = result.data;
          yield put(
            productActions.toggleModal({
              name: 'excelBulkEditProductDiscountFailModal',
              value: true,
              data: {
                requestCnt: productList.length,
                possibleCnt: filter(productList, (item) => !item.isInvalid).length,
                impossibleCnt: filter(productList, (item) => item.isInvalid).length,
                productList,
              },
            }),
          );
        }
      }
    } catch (error) {
      toastMsg.error(error.message || productToastMsg.EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST_ERROR);
    }
  });

  /**
   * [상품 전체 리스트] 상품 전체 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductAllListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || productToastMsg.GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   * [상품 전체 리스트] 상품 전체 풀필먼트 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(productActions.GET_PRODUCT_ALL_FULFILLMENT_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getProductAllFulfillmentListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(error.message || productToastMsg.GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  상품 일괄 편집 유효성 체크하기
   */
  yield takeEvery(productActions.GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getBulkEditProductValidateResultList, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      yield put(
        productActions.setData({
          path: ['excelBulkEditProduct'],
          value: {
            file: payload.attachment ? payload.attachment[0] : [],
            bulkEditProductValidResultList: result.data.bulkEditProductValidResultList,
            bulkEditProductValidResultCount: result.data.bulkEditProductValidResultCount,
          },
        }),
      );
    } catch (e) {
      toastMsg.error(productToastMsg.GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  상품 일괄 편집 하기
   */
  yield takeEvery(productActions.BULK_EDIT_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.bulkEditProduct, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(productToastMsg.BULK_EDIT_PRODUCT_REQUEST_SUCCESS);
    } catch (e) {
      toastMsg.error(productToastMsg.BULK_EDIT_PRODUCT_REQUEST_ERROR, e);
    }
  });

  /**
   *  [상품 리스트] 태그 리스트 가져오기
   */
  yield takeEvery(productActions.GET_PRODUCT_TAG_LIST_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(ProductApi.getSearchTagList, setRequestForm(payload));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      yield put(
        productActions.setData({
          path: ['productList', 'tagList'],
          value: result.data.tagList,
        }),
      );
    } catch (e) {
      toastMsg.error();
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
